import React from 'react';
import { FileText, Video, ChevronRight } from 'lucide-react';
export function Newsletters2020Section() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3328">
      <div className="bg-[#1874cd] py-4 px-6" data-id="element-3329">
        <h2 className="text-2xl font-bold text-white" data-id="element-3330">Newsletters 2020</h2>
      </div>
      <div className="p-8 space-y-8" data-id="element-3331">
        <ul className="space-y-4" data-id="element-3332">
          <li className="flex flex-col" data-id="element-3333">
            <div className="flex items-start" data-id="element-3334">
              <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3335" />
              <a href="https://myemail.constantcontact.com/Missing-out-on-the-benefits-of-5-Axis-.html?soid=1133237142700&aid=RrF2gnzy6no" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3336">
                Mikron MILL E - January 2020
              </a>
            </div>
            <ul className="ml-8 mt-2 space-y-2" data-id="element-3337">
              <li className="flex items-center" data-id="element-3338">
                <ChevronRight className="h-4 w-4 text-gray-400 mr-2" data-id="element-3339" />
                <a href="https://myemail.constantcontact.com/Missing-out-on-the-benefits-of-5-Axis-.html?soid=1133237142700&aid=RrF2gnzy6no" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-orange transition-colors" data-id="element-3340">
                  Smart 5-Axis Machining Capabilities
                </a>
              </li>
            </ul>
          </li>
          <li className="flex items-start" data-id="element-3341">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3342" />
            <a href="https://myemail.constantcontact.com/--We-ve-Eliminated-EDM-Wire-Breakage--.html?soid=1133237142700&aid=TM_UZvT4sZ8" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3343">
              Eliminating EDM Wire Breakage
            </a>
          </li>
          <li className="flex items-start" data-id="element-3344">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3345" />
            <a href="https://myemail.constantcontact.com/5-Axis-Machining-Made-Easy.html?soid=1133237142700&aid=A5957hrYx94" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3346">
              5-Axis Machining Made Easy
            </a>
          </li>
          <li className="flex items-start" data-id="element-3347">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3348" />
            <a href="https://conta.cc/3dDw60f" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3349">
              EDM Consumables
            </a>
          </li>
          <li className="flex items-start" data-id="element-3350">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3351" />
            <a href="https://conta.cc/3hcphE4" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3352">
              System3R Promotion
            </a>
          </li>
          <li className="flex items-start" data-id="element-3353">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3354" />
            <a href="https://conta.cc/3cSmUpC" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3355">
              High Speed Mill Construction Comparison
            </a>
          </li>
          <li className="flex items-start" data-id="element-3356">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3357" />
            <a href="https://conta.cc/3t8dlc9" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3358">
              GFMS Big Summer Blowout
            </a>
          </li>
          <li className="flex items-start" data-id="element-3359">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3360" />
            <a href="https://conta.cc/31PbaOD" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3361">
              Buy Now - Pay Next Year
            </a>
          </li>
        </ul>

        <div className="pt-6 border-t border-gray-100" data-id="element-3362">
          <h3 className="text-xl font-bold text-navy mb-4" data-id="element-3363">
            Webinars & Events:
          </h3>
          <ul className="space-y-4" data-id="element-3364">
            <li className="flex items-start" data-id="element-3365">
              <Video className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3366" />
              <a href="https://conta.cc/2Orpc5V" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3367">
                Additive Manufacturing Workflow Webinar
              </a>
            </li>
            <li className="flex items-start" data-id="element-3368">
              <Video className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3369" />
              <a href="https://conta.cc/31NYpDM" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3370">
                Surgical Instruments: Integrated & Automated Manufacturing
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>;
}